/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type CurrencySelector_user = {
    readonly id: string;
    readonly serviceId: string | null;
    readonly profile: {
        readonly currency: Currency | null;
    } | null;
    readonly " $refType": "CurrencySelector_user";
};
export type CurrencySelector_user$data = CurrencySelector_user;
export type CurrencySelector_user$key = {
    readonly " $data"?: CurrencySelector_user$data;
    readonly " $fragmentRefs": FragmentRefs<"CurrencySelector_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CurrencySelector_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '3a8ac1876dcc70c5f03e88f37725caf1';
export default node;
